import filter from "lodash/filter";
import find from "lodash/find";
import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";
import { ValidatorInterface } from "@/Models/Validators/ValidatorInterface";

export enum Axis {
	X = 'x',
	Y = 'y',
}

export function createValidatorInstance( validator: Function, options: object ): ValidatorInterface {

	// Return early if fields are missing.
	const requiredProperties = [ 'instance', 'dimension', 'field' ];
	if ( !requiredProperties.every( property => property in options ) ) {
		return null;
	}

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return new validator( options );
}

export function getValidationErrors( validators: ValidatorInterface[], field?: string, shouldAllFail = false ): ValidatorInterface[] {
	if ( isUndefined( validators ) ) {
		return [];
	}

	const filtered = filter( validators, function ( validator: ValidatorInterface ) {
		return !validator.isValid();
	} );

	if ( shouldAllFail ) {
		return ( validators.length > 0 && filtered.length > 0 ) && filtered.length === validators.length ? filtered : [];
	}

	if ( field ) {
		const fieldSpecific = find( filtered, { field } );

		return !isUndefined( fieldSpecific ) ? [ fieldSpecific ] : [];
	}

	return filtered;
}

export function hasValidationErrors( validators: ValidatorInterface[], field?: string, shouldAllFail = false ): boolean {
	const errors = getValidationErrors( validators, field, shouldAllFail );

	return !isEmpty( errors );
}

export function getValidationMessageForField( validators: ValidatorInterface[], field: string ): string {
	const errors = getValidationErrors( validators, field );

	if ( isEmpty( errors ) ) {
		return;
	}

	return errors[ 0 ].getMessage();
}
